<template>
  <div>
    <form class="form-validation">
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link :to="{ name: 'combo_list', params: { search: search } }" class="btn btn-ptc1" tag="button">返回</router-link>
        </b-col>
        <b-col class="text-center title">線上點餐管理 / 套餐管理 / 修改</b-col>
        <b-col>
          <div class="text-right">
            <button type="button" class="btn btn-save" @click="save">儲存</button>
          </div>
        </b-col>
      </b-row>

      <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-7">
              <div class='row mb-3'>
                <label class='control-label col-md-3'>餐點名稱：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='title' placeholder='請輸入餐點名稱' maxlength="30" >
                  <div class="text-danger" v-if="valid_title&&!title">{{valid_title}}</div>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售週期：</label>
                <div class='col-md-7'>
                  <b-form-group>
                    <b-form-checkbox-group id="checkbox-group-1" v-model="week" :options="optionsWeek" name="flavour-1" ></b-form-checkbox-group>
                  </b-form-group>
                  <div class="text-danger" v-show="this.valid_WeekMsg != ''">{{this.valid_WeekMsg}}</div>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售對象：</label>
                <div class='col-md-7'>
                  <input type='radio' name='rdoGroup' value=1 v-model='MemberType'>
                    <label for='MemberType1'>全部會員</label>
                  <input type='radio' name='rdoGroup' value=2 v-model='MemberType'>
                    <label for='MemberType2'>正式會員</label>
                </div>
              </div>

              <div class='row mb-3'>
                <label class='control-label col-md-3'>備註：</label>
                <div class='col-md-7'>
                  <input type='text' name='Input_Memo' class='form-control' v-model.trim='Memo' placeholder='請輸入備註' maxlength="30" >
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">圖片上傳</label>
                  <input type="file" class="upload_input" id="pic" ref="inputer" accept="image/*" multiple @change="handleFileChange">
                  <label class="upload_block" for="pic">
                    <span class="upload_icon">➕</span>
                    <img class="upload_img" v-if="img_url != undefined" :src="file==undefined? img_url : img_url">
                  </label>
                  <br />
                  <!-- <div class="text-danger" v-if="valid_img_url">{{valid_img_url}}</div> -->
                  <span class="text-danger">※限制上傳一張圖片，建議尺寸為800x600</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-lg-7'>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>套餐品項：</label>
                <div class='col-md-7'>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
          </div>
          <template>
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-0 variant="info">主餐</b-button>
      </b-card-header>
      <b-collapse id="accordion-0" visible role="tabpanel">
        <b-card-body>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>折扣金額：</label>
                <div class='col-md-7'>
                  <input type='number' class='form-control' v-model.trim='MainDiscount' placeholder='請輸入折扣金額' maxlength="5" disabled>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>品項：</label>
                <div class='col-md-7'>
                  <multiselect v-model="MainProduct" disabled :options="products" :custom-label="nameWithLang" :multiple="false" group-values="Detail" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" :show-labels="false">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                  <div class="text-danger" v-if="valid_MainProduct&&!MainProduct">{{valid_MainProduct}}</div>
                </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <div v-for="(list,index) in lists" :key="index">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="'accordion-'+index+1" variant="info">搭配{{index+1}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+index+1" visible role="tabpanel">
        <b-card-body>
          <div class='row mb-3'>
            <div class='col-md-12'>
            </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>APP顯示文字：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='list.AppShowWord' placeholder='請輸入APP顯示文字' maxlength="30" required>
                  <div class="text-danger" v-if="list.valid_AppShowWord&&!list.AppShowWord">{{list.valid_AppShowWord}}</div>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>折扣金額：</label>
                <div class='col-md-3'>
                  <div v-if="!list.IsRequired">
                  <input type='number' class='form-control' v-model.trim='list.Discount' placeholder='請輸入折扣金額' maxlength="5" disabled>
                  <div class="text-danger" v-if="list.valid_Discount">{{list.valid_Discount}}</div>
                  </div>
                </div>
                <div class='col-md-1'>
                </div>
                <label class='control-label col-md-2'>是否必選：</label>
                <div class='col-md-3'>
                  <toggle-button v-model="list.IsRequired" :width=60 :height=30 :sync="true" style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}" disabled/>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>搭配型態：</label>
                <div class='col-md-7'>
                  <input type='radio' :name="('rdoType'+index)" value='2' v-model='list.OptionType' disabled>
                    <label for='OptionType1'>POS分類</label>
                  <input type='radio' :name="('rdoType'+index)" value='1' v-model='list.OptionType' disabled>
                    <label for='OptionType2'>單品</label>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>更換商品：</label>
                <div class='col-md-7'>
                  <multiselect v-model="list.OptionProduct2" :options="productAttributes" :multiple="true" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" v-if="list.OptionType=='2'" @input="onChange" :show-labels="false" @remove="onOptionProductChange(index)" @select="onOptionProductChange(index)" disabled></multiselect>
                  <div class="text-danger" v-if="list.valid_OptionProduct2&&list.OptionType=='2'">{{list.valid_OptionProduct2}}</div>
                  <multiselect v-model="list.OptionProduct1" :options="products2" :multiple="true" :custom-label="nameWithLang" group-values="Detail" group-label="Attribute" :group-select="true" placeholder="請選擇" track-by="Name" label="Name" v-if="list.OptionType=='1'" @input="onChange" :show-labels="false" @remove="onOptionProductChange(index)" @select="onOptionProductChange(index)" disabled>
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                  <div class="text-danger" v-if="list.valid_OptionProduct1&&list.OptionType=='1'">{{list.valid_OptionProduct1}}</div>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>預設商品：</label>
                <div class='col-md-7' :class="{ active: !list.IsRequired }">
                  <multiselect v-model="list.DefaultProduct" :options="list.DefProducts" :custom-label="nameWithLang" :multiple="false" placeholder="請選擇" track-by="Name" label="Name"  @open="getDefProducts(index)" @input="onChange" :show-labels="false">
                  </multiselect>
                  <div class="text-danger" v-if="list.valid_DefaultProduct">{{list.valid_DefaultProduct}}</div>
                </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    </div>
  </div>
          </template>
        </b-card>

        <!-- Double Check Modal -->
        <b-modal ref="mdCheck" hide-footer title="套餐變更">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label">確定變更此套餐 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="confirm">確定</b-btn>
                <b-btn variant="secondary" @click="cancel">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

      </div>
    </form>
  </div>
</template>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      isActive: true,
      id: 0,
      title: '',
      MemberType: 1,
      Memo: '',
      img_url: undefined,
      apiUrl: API_URL,
      week: [],
      MainDiscount: '',
      MainProduct: '',
      valid_errMsg: false,
      valid_title: '',
      valid_img_url: '',
      valid_WeekMsg: '',
      valid_MainProduct: '',
      search: {}, // 記錄查詢條件
      FunctionPermission: 0,
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      products: [],
      products2: [],
      productAttributes: [],
      lists: [{
        ComboOptionID: 0,
        AppShowWord: '',
        Discount: '',
        IsRequired: false,
        OptionType: '2',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: [],
        DefProducts: [], // user選擇搭配的商品清單
        DefaultProduct: '',
        valid_AppShowWord: '',
        valid_Discount: '',
        valid_OptionProduct1: '',
        valid_OptionProduct2: '',
        valid_DefaultProduct: '',
        OptionProductChange: false
      }]
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F17') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'combo_list' })
      return
    }

    var params = this.$route.params
    if (params.item === undefined) {
      this.$router.push({ name: 'combo_list' })
      return
    }

    var item = params.item
    this.action = params.action
    this.search = params.search
    console.log(this.search)
    this.id = item.ID
    this.title = item.Name
    this.img_url = item.ImageURL
    console.log(item.ImageURL)
    console.log(this.img_url)
    this.MemberType = item.MemberType
    this.Memo = item.Memo
    this.week = JSON.parse('[' + item.Week + ']')
    this.MainDiscount = item.MainDiscount
    // this.link_color = item.LinkColor
    // this.status = item.Status
    // this.updated_at = item.WebUpdatedAt
    this.getAllProducts(item.MainProductCode)
    this.getOption(item.ID)
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    addOption () {
      let cope = {
        ComboOptionID: 0,
        AppShowWord: '',
        Discount: '',
        IsRequired: false,
        OptionType: '2',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: [],
        DefProducts: [],
        DefaultProduct: '',
        valid_Discount1: '',
        valid_OptionProduct1: '',
        valid_OptionProduct2: '',
        valid_DefaultProduct: '',
        OptionProductChange: false
      }
      this.lists.push(cope)
      console.log(this.lists)
    },
    // 因為不知道為什麼,放了預設值的配餐的下拉選單,修改選項後不會即時更新,改OptionType後才會更新
    onChange () {
      if (this.lists[0].OptionType === '2') {
        this.lists[0].OptionType = '1'
        this.lists[0].OptionType = '2'
      }
      if (this.lists[0].OptionType === '1') {
        this.lists[0].OptionType = '2'
        this.lists[0].OptionType = '1'
      }
    },
    // 取得商品類別與明細(不含group) [取得主餐]
    getAllProducts (MainProductCode) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: true,
        hasExtra: false,
        hasCombo: false
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          if (response.data.result === '0000') {
            this.products = response.data.data
            var det
            var alldet = ''
            for (var p in response.data.data) {
              det = JSON.stringify(response.data.data[p].Detail) // 去除前後的'[',']'
              alldet = alldet + det.substr(1, det.length - 2) + ',' // 組成{},{},{},
            }
            alldet = alldet.substr(0, alldet.length - 1)
            this.MainProduct = JSON.parse('[' + alldet + ']').find(product => product.Code === MainProductCode)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '主餐資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '主餐資料讀取異常2')
          console.log(error)
        })
    },
    // [取得搭配]
    getOption (ID) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getComboOptions/v1', {
        status: ID
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          if (response.data.result === '0000') {
            for (var p in response.data.data) {
              if (p !== '0') {
                this.addOption()
              }
              this.lists[p].ComboOptionID = response.data.data[p].ComboOptionID
              this.lists[p].AppShowWord = response.data.data[p].AppShowWord
              this.lists[p].Discount = response.data.data[p].Discount
              this.lists[p].IsRequired = response.data.data[p].IsRequired
              this.lists[p].OptionType = response.data.data[p].OptionType
              this.lists[p].DefaultProduct = response.data.data[p].DefaultProduct
              this.lists[p].DefaultIsGroup = response.data.data[p].DefaultIsGroup
              this.lists[p].OptionProduct = response.data.data[p].OptionProduct
            }
            // 取得this.lists再跑下面
            this.getAllProducts2()
            this.getAllProductAttributes()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '搭配資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '搭配資料讀取異常2')
          console.log(error)
        })
    },
    // 取得商品類別與明細(含group)
    getAllProducts2 () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 2,
        hasDelete: false,
        hasExtra: true,
        hasCombo: false
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          if (response.data.result === '0000') {
            this.products2 = response.data.data
            // 塞值
            for (var i in this.lists) {
              if (this.lists[i].OptionType === '1') {
                this.lists[i].OptionProduct1 = this.lists[i].OptionProduct
                this.getDefProducts(i)
              }
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品類別與明細資料讀取異常(含group)')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品類別與明細資料讀取異常(含group)2')
          console.log(error)
        })
    },
    // 取得商品類別
    getAllProductAttributes () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproductAttributes/v1', {
        status: 1
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          if (response.data.result === '0000') {
            this.productAttributes = response.data.data
            // 塞值
            for (var p in this.lists) {
              if (this.lists[p].OptionType === '2') {
                this.lists[p].OptionProduct2 = this.lists[p].OptionProduct
                this.getDefProducts(p)
              }
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品類別讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品類別讀取異常2')
          console.log(error)
        })
    },
    // user所選搭配的商品列表
    getDefProducts (index) {
      if (this.lists[index].IsRequired === false) {
        // miniToastr.info('非必選，不需選擇預設商品')
      } else {
        this.$parent.Loading = true
        var option = []
        if (this.lists[index].OptionType === '1') {
          option = this.lists[index].OptionProduct1
        } else {
          option = this.lists[index].OptionProduct2
        }
        return axios.post(API_URL + '/web/shopping/getDefProducts/v1', {
          OptionProduct: option
        })
          .then((response) => {
            this.$store.commit('TOKEN', response.data.jwt)
            if (response.data.result === '0000') {
              // var a = this.lists[index].DefaultProduct
              // this.lists[index].DefaultProduct = ''
              this.lists[index].DefProducts = response.data.data
              // this.lists[index].DefaultProduct = a
            } else if (response.data.result === '0006') {
              this.$parent.logOut(true, true)
            } else {
              miniToastr.error(response.data.message, '商品資料讀取異常')
              console.log(response.data.message)
            }
            this.$parent.Loading = false
          })
          .catch((error) => {
            this.$parent.Loading = false
            miniToastr.error(error, '商品資料讀取異常')
            console.log(error)
          })
      }
    },
    save () {
      console.log('save()')
      this.valid_errMsg = false
      for (var p in this.lists) {
        console.log(this.lists[p].OptionProduct1[0])
        console.log(this.lists[p].OptionProduct2[0])
        if (this.lists[p].OptionType === '1' || this.lists[p].OptionType === 1) {
          if (this.lists[p].OptionProduct1[0] === undefined || this.lists[p].OptionProduct1 === null) {
            this.valid_errMsg = true
            this.lists[p].valid_OptionProduct1 = 'POS類別為必選'
            miniToastr.error('請選擇搭配' + (Number(p) + 1).toString() + '的POS類別')
          } else {
            this.lists[p].OptionProduct = this.lists[p].OptionProduct1
            this.lists[p].valid_OptionProduct1 = ''
          }
          this.lists[p].valid_OptionProduct2 = ''
        } else {
          if (this.lists[p].OptionProduct2[0] === undefined || this.lists[p].OptionProduct2 === null) {
            this.valid_errMsg = true
            this.lists[p].valid_OptionProduct2 = 'POS類別為必選'
            miniToastr.error('請選擇搭配' + (Number(p) + 1).toString() + '的POS類別')
          } else {
            this.lists[p].OptionProduct = this.lists[p].OptionProduct2
            this.lists[p].valid_OptionProduct2 = ''
          }
          this.lists[p].valid_OptionProduct1 = ''
        }
        if (this.lists[p].IsRequired) {
          if (!this.lists[p].DefaultProduct.Code || this.lists[p].DefaultProduct.Code === '') {
            this.valid_errMsg = true
            this.lists[p].valid_DefaultProduct = '預設商品為必選'
          } else {
            this.lists[p].valid_DefaultProduct = ''
          }
        } else {
          if (!this.lists[p].Discount) {
            this.valid_errMsg = true
            miniToastr.error('請輸入折扣金額')
          } else {
            this.lists[p].valid_Discount = ''
          }
        }
      }
      if (!this.title) {
        this.valid_errMsg = true
        this.valid_title = '標題為必填'
      }
      // if (!this.img_url) {
      //   this.valid_errMsg = true
      //   this.valid_img_url = '圖片為必選'
      // }
      if (!this.week || this.week.length <= 0) {
        this.valid_errMsg = true
        this.valid_WeekMsg = '請至少勾選一個週期'
      } else {
        this.valid_WeekMsg = ''
      }
      if (!this.MainProduct.Code) {
        this.valid_errMsg = true
        this.valid_MainProduct = '品項為必選'
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true
      for (var p in this.lists) {
        if (this.lists[p].IsRequired) {
          this.lists[p].Discount = ''
        } else {
          this.lists[p].DefaultProduct = JSON.parse('{"Code":"", "Name":"", "ItemType":0 }')
        }
      }
      var arrAll = {
        id: this.id,
        name: this.title,
        Memo: this.Memo,
        MemberType: Number(this.MemberType),
        week: this.week.toString(),
        MainDiscount: Number(this.MainDiscount),
        MainProductCode: this.MainProduct.Code,
        lists: this.lists
      }
      console.log(this.file)
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('data', JSON.stringify(arrAll))

      var config = {
        headers: {
          'Content-Type': undefined
        }
      }
      return axios.post(API_URL + '/web/shopping/updatecombo/v1',
        formData, config
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('套餐已變更')
            this.$router.push({ name: 'combo_list', params: { search: this.search } })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更失敗')
          console.log(error)
        })
    },
    handleFileChange (e) {
      this.valid_img_url = ''
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      this.fileName = this.file.name
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.img_url = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.img_url = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    onOptionProductChange (i) {
      this.lists[i].OptionProductChange = true
    }
  }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 257px;
  height: 220px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 40%;
}
.block {
  height: 454pt;
}
.active {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/combo/Edit.vue